



































import { computed, defineComponent, ref } from '@vue/composition-api';
import axios from 'axios';

import UserPassword from '@/components/UserPassword.vue';
import { SERVER_URL } from '@/environment';

export default defineComponent({
  name: 'ResetPassword',
  components: { UserPassword },
  setup(props, ctx) {
    const token = typeof ctx.root.$route.query.token === 'string' ? ctx.root.$route.query.token : '';
    const password = ref('');
    const confirmPassword = ref('');
    const formValid = ref(false);
    const submitting = ref(false);
    const message = ref(token ? '' : 'This password reset link is invalid.');
    const messageType = ref<'success' | 'error'>(token ? 'success' : 'error');
    const canSubmit = computed(() => token && formValid.value && password.value === confirmPassword.value);

    function updatePassword(value: string) { password.value = value; }
    function updateConfirmPassword(value: string) { confirmPassword.value = value; }

    async function resetPassword() {
      if (!canSubmit.value) { return; }
      submitting.value = true;
      message.value = '';
      try {
        const response = await axios.post(`${SERVER_URL}/auth/password-reset/confirm`, {
          token,
          password: password.value,
        });
        message.value = response.data;
        messageType.value = 'success';
      } catch (error) {
        const response = (error as { response?: { data?: string } }).response;
        message.value = response?.data || 'Unable to reset password; please try again later.';
        messageType.value = 'error';
      } finally {
        submitting.value = false;
      }
    }

    return {
      UserPassword,
      canSubmit,
      formValid,
      message,
      messageType,
      resetPassword,
      submitting,
      updateConfirmPassword,
      updatePassword,
    };
  },
});
